<script lang="ts">
	//Design system components
	import { Button, Container, IconButton, Modal, Text } from '@Shelly/shelly-design-system';
	//Helpers
	import { copy } from 'src/helpers/copy_text';
	//Services
	import { format } from 'svelte-i18n';

	export let showTariffInstruction = false;
	export let name = '';
	export let url = '';
	export let host = '';
</script>

<Modal
	showModal={showTariffInstruction}
	on:close={() => (showTariffInstruction = false)}
	title={$format('title_setup_live_tariff', {
		default: 'How To Set Up Live Tariff',
	})}
>
	<Container slot="content" padding="0">
		<Text element="h2" class="mb-m">
			{$format('live_tariff_instruction_one', {
				default: `You can set up your own script that will send requests to update your ${name} price.`,
				values: { name },
			})}
		</Text>

		<Container class="width-xl mb-m " type="borderSolid" padding="xs">
			<div class="content-background dark d-flex align-items-center">
				<Text styleType="body-small" class="text-white-space-nowrap text-bold mr-xs"
					>{$format('live_tariff_request_url', {
						default: `Request URL:`,
					})}</Text
				>
				<Text noWrap class="width-full text-small link-styles">{host + url}</Text>
				<IconButton
					aria-label={$format('button_copy_url', { default: 'Copy url' })}
					class="ml-m"
					icon="fas fa-copy"
					size="m"
					width="s"
					on:click={() =>
						copy(
							host + url,
							$format('copied_successfully', {
								default: 'Copied successfully!',
							}),
						)}
				/>
			</div>
		</Container>
		<Container class="width-auto mb-m " type="borderSolid" padding="xs">
			<div class="content-background dark d-flex justify-content-start align-items-center">
				<Text styleType="body-small" class="text-white-space-nowrap text-bold mr-xs"
					>{$format('live_tariff_request_type', {
						default: `Request Type:`,
					})}</Text
				>
				<Text styleType="body-small" class="width-full">{`POST`}</Text>
			</div>
		</Container>
		<Container class="width-auto mb-m " type="borderSolid" padding="xs">
			<div class="content-background dark d-flex justify-content-start align-items-center">
				<Text styleType="body-small" class="text-white-space-nowrap text-bold mr-xs"
					>{$format('live_tariff_parameters', {
						default: `Parameters:`,
					})}</Text
				>
				<Text styleType="body-small" class="width-full">{`"price"`}</Text>
			</div>
		</Container>
		<Text class="mb-s align-center d-flex justify-content-center text-bold"
			>{$format('live_tariff_quick_example', {
				default: `Here is a quick example:`,
			})}</Text
		>
		<Container class="width-auto mb-m " type="borderSolid" padding="xs">
			<div class="content-background dark d-flex justify-content-center">
				<Text class="mb-s text-bold"
					>{$format('live_tariff_example_request', {
						default: `Request:`,
					})}</Text
				>
			</div>
			<Container class="width-auto" type="base" padding="xs">
				<div class="content-background justify-content-start">
					<!-- the following lines maybe will remain untranslated -->
					<Text styleType="body-small" breakWord class="mb-xs">
						{$format('curl_example_one', {
							default: `curl -X POST ${host}/{{TOKEN}}\\`,
						})}
					</Text>
					<Text styleType="body-small" breakWord class="mb-xs">
						{$format('curl_example_two', {
							default: `-H "Content-Type: application/json"\\`,
						})}
					</Text>
					<Text styleType="body-small" breakWord>
						{$format('curl_example_three', {
							default: `-d '{"price": "6.5"}'`,
						})}
					</Text>
					<!-- end of untranslated lines -->
				</div>
			</Container>
		</Container>
		<Container class="width-auto mb-m " type="borderSolid" padding="xs">
			<div class="content-background dark d-flex justify-content-center">
				<Text class="mb-s text-bold"
					>{$format('live_tariff_example_response', {
						default: `Response:`,
					})}</Text
				>
			</div>
			<Container class="width-auto" type="base" padding="xs">
				<div class="content-background d-flex justify-content-start">
					<!-- the following lines maybe will remain untranslated -->
					<Text styleType="body-small" breakWord>
						{$format('live_tariff_example_response_one', {
							default: `{ "price": 6.5 }`,
						})}
					</Text>
					<!-- end of untranslated lines -->
				</div>
			</Container>
		</Container>
		<div class="content-background dark d-flex justify-content-center">
			<Button
				class="width-md-m width-sm-full mb-s"
				size="m"
				on:click={() => (showTariffInstruction = false)}
			>
				{$format('okay_got_it', { default: 'Okay, got it.' })}
			</Button>
		</div>
	</Container>
</Modal>
